import { AnalysisWithId } from '@livv/models';
import useTranslation from 'next-translate/useTranslation';
import { FC, useContext } from 'react';
import DisplayFullText from '@components/FullText/DisplayFullText';
import { DecisionSearchContext } from '@components/search/DecisionSearch/DecisionSearchProvider';

interface AnalysisContentProps {
    analysis: AnalysisWithId;
    isSearchTarget?: boolean;
    showTranslationVersion: boolean;
}

const AnalysisContent: FC<AnalysisContentProps> = ({
    analysis,
    isSearchTarget,
    showTranslationVersion,
}) => {
    const searchContext = useContext(DecisionSearchContext);
    const { content, translation } = analysis;
    const { t } = useTranslation('decision');

    const rawContent = showTranslationVersion ? translation : content;

    return (
        <DisplayFullText
            containerSx={{ m: 0 }}
            contentSx={{ fontSize: 'inherit' }}
            dataTestId={`${showTranslationVersion ? 'translation' : 'content'}-full-text`}
            setSearchTarget={isSearchTarget ? searchContext?.setAnalysisTarget : undefined}
            unsanitizedContent={rawContent || t('translateAnalysis.missing')}
        />
    );
};

export default AnalysisContent;
